export const i16z = {
  i16r: { // user
    v0: {
      itlz: {
        i16r_31r1f: -1,
      },
      fldz: {
        i16r_31r1f: {
          pfx: '施設' 
        },
      },
    },
  },
};
